<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card border-variant="primary">
          <template slot="header">
            <i class='fa fa-align-justify'></i>QNA
          </template>
          <!-- detail search start -->
          <b-card v-show="so.adv">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="opt_question_at"> Question_at
                  <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
                </label>
                <b-form inline>
                  <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                  ~
                  <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                </b-form>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="opt_answered_at"> Answered_at
                  <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1d', 'answered_at')">-1D</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1w', 'answered_at')">-1W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1m', 'answered_at')">-1M</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('w', 'answered_at')">W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('m', 'answered_at')">M</b-button>
                </label>
                <b-form inline>
                  <date-picker @change="refresh" v-model="so.opt.answered_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                  ~
                  <date-picker @change="refresh" v-model="so.opt.answered_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                </b-form>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="opt_group">Status</label>
                <br>
                <select v-model="so.opt['is_answered']" @change="refresh">
                    <option disabled value="">Please select waiting or done</option>
                    <option value="true">done</option>
                    <option value="false">waiting</option>
                  </select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="opt_type">Solution</label>
                <br>
                <!-- <v-select label="text" v-model="so.opt['type']" :options="codes.BOARD_TYPE" @change="$refs._list.refresh()"></v-select> -->
                <select v-model="so.opt['type']" @change="$refs._list.refresh()">
                  <option disabled value="">Please select solution</option>
                  <option value="wmds">WMDS : Web Malware Detection System</option>
                  <option value="wsfinder">WSFinder : WeShell Finder</option>
                  <option value="webcastle">WEBCastle : Web Firewall</option>
                  <option value="etc">Etc</option>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" v-if="!user">
              <b-form-group>
                <label for="opt_title_qna">Title</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_title_qna" v-model="so.opt['title']"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_qna_answer">Answer</label>
                <b-form-input @keydown.enter="refresh" type="text" id="ph_qna_answer" v-model="so.opt['answer']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="opt_agent">Agent</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_agent" v-model="so.opt['agent']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col md="12">
              <label for="ph_search_opt_type">Match Type</label>
              <b-form-group>
                <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                  <b-form-radio value="and">[AND]:Match all</b-form-radio>
                  <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group class="float-right">
            <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
            <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
            <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
          </b-form-group>
        </b-card>
        <!-- detail search end -->
        <hr>
          <b-row>
            <b-col sm="2">
              <b-badge class="mx-2" :variant="color[index % color.length]" v-for="(item, index) in _summary" :key="item.type">
                {{item.type ? `${item.type.toUpperCase()} waiting : ${item.count}` : ''}}
              </b-badge>
            </b-col>
            <b-col sm="10" class="md-10">
              <b-input-group size="sm">
                <b-input-group-prepend>
                  <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
                  <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
                  <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                    <!-- <b-dropdown-item v-if="!user" size="sm" @click="so.sk='type';so.skt='Solution'; so.sv = ''">Solution</b-dropdown-item> -->
                    <b-dropdown-item size="sm" @click="so.sk='is_answered';so.skt='Status'; so.sv = ''">Status</b-dropdown-item>
                    <b-dropdown-item size="sm" @click="so.sk='title';so.skt='Title'; so.sv = ''">Title</b-dropdown-item>
                  </b-dropdown>
                  <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_answered'" @change="$refs._list.refresh()">
                    <option disabled value="">Please select waiting or done</option>
                    <option value="true">done</option>
                    <option value="false">waiting</option>
                  </select>
                </b-input-group-prepend>
                <b-form-input :disabled="so.adv" v-if="so.sk != 'is_answered'" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
                  <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-input-group size="sm">
                <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Show count : Default 15</option>
                    <option value=10>10</option>
                    <option value=50>50</option>
                    <option value=100>100</option>
                  </select>
                  <!-- <v-select label="text" v-model="type" :options="board_type"></v-select> -->
                  <select v-model="type" @change="$refs._list.refresh()">
                    <option disabled value="">Please select solution</option>
                    <option value="wmds">WMDS : Web Malware Detection System</option>
                    <option value="wsfinder">WSFinder : WeShell Finder</option>
                    <option value="webcastle">WEBCastle : Web Firewall</option>
                    <option value="etc">Etc</option>
                  </select>

                  <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Please select interval : Default 15</option>
                    <option value=10>10</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=300>300(5 min)</option>
                  </select>
                  <span v-if="sync.enable" class="float-right" style="margin-right:15px">
                    <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
                    <b-btn @click="pause" size="sm" variant="warning">
                      {{!sync.stop ? "Auto refresh"  : "Pause"}}
                    </b-btn>
                  </span>
              </b-input-group>
            </b-col>
          </b-row>
          <hr>
          <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="group.groupname" slot-scope="row">{{row.item.group ? row.item.group.groupname : '-'}}</template>
            <template slot="group.service" slot-scope="row">{{row.item.group ? row.item.group.service : '-'}}</template>
            <template slot="type" slot-scope="row">{{row.item.type}}</template>
            <template slot="title" slot-scope="row">{{row.item.title}}</template>
            <template slot="answer" slot-scope="row">{{row.item.answer ? 'Done' : 'Waitting'}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
            <template slot="func" slot-scope="row">
              <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
            </template>
          </b-table>
          <hr>
          <b-row>
            <b-col class="md-8">
              <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import { Api } from '@/service';
import  codes from '@/codes';
import vSelect from 'vue-select';

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: 'username', sv: '', skt: 'username', opt : { type : '', is_answered : '' }, adv: false
});

// props explain
// auto_refresh[default=false] : auth sync enable or disable, value is boolean
// user : this component to user list, using by user dependency

export default {
  name : "QnaList",
  props: ['user', 'auto_refresh', 'group', 'partner', 'only_view'],
  components: { DatePicker, vSelect },
  data: () => ({
    codes,
    color : ['info', 'danger', 'primary', 'secondary', 'warning', 'light'],
    custom,
    so : default_opt(),
    sync : { interval : 15, stop : false, th : undefined, enable : false },
    summary_data : [],
    type : '',
  }),
  computed: {
    board_type() {
      return _.uniqBy(Object.keys(codes.BOARD_TYPE), x => x.toUpperCase())
    },
    _summary() { return this.summary_data },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'group.groupname', label: 'Group', sortable: true },
        { key: 'group.service', label: 'Service', sortable: true },
        { key: 'type', label: 'Solution', sortable: true },
        { key: 'title', label: 'Title', sortable: true },
        { key: 'answer', label: 'Answer', sortable: true },
        { key: 'created_at', label: 'Date', sortable: true },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
    ]}
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['answered_at_ed'] = moment().startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.opt['type'] = '';
        this.so.opt['is_answered'] = '';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let and = [this.set_op('is_del', 'false')]
      let so = {
        target : 'board.qna', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : and  },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.user) { so.body.and.push({ name : 'user_id', value : this.user.id, op : '=' }) }
      if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '=' }) }
      if(this.partner) { so.body.and.push({ name : 'partner_id', value : this.partner.id, op : '=' }) }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)) }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'answered_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'answered_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'type':
              cond = this.set_op(k[i], this.so.opt[k[i]].value ? this.so.opt[k[i]].value : '');
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      if(this.type) { so.body.and.push(this.set_op('type', this.type.value)); }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) {
      this.$router.push({ name : 'board_qna', params : { id : item.id } });
    },
    summary() {
      let body = { ts : new Date().getTime(), };
      if(this.user) { body.user_id = this.user.id }
      if(this.group) { body.group_id = this.group.id }
      if(this.partner) { body.partner_id = this.partner.id }

      Api.Manager({ target : 'board.qna', cmd : 'summary', body : body })
        .then(rs => this.summary_data = rs.body)
        .catch(e => {
          console.log(e)
          this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
        });
    },
  },
  created() { console.log('board.qna.vue', 'created'); },
  destroyed() { console.log('board.qna.vue', 'destroyed'); },
  mounted() {
    console.log('board.qna.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      this.so.sk = 'addr'
      this.so.skt = 'Address'
    }
    setTimeout(this.summary, 1000)
  },
}
</script>
